import axios from 'axios';
const URL_BRASILAPI = 'https://brasilapi.com.br/api';

function getBanks() {
  return new Promise((resolve, reject) => {
    axios.get(`${URL_BRASILAPI}/banks/v1`)
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}
function getBanksByCode(code) {
  return new Promise((resolve, reject) => {
    axios.get(`${URL_BRASILAPI}/banks/v1/ ${code}`)
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}


export default {
  getBanks,
  getBanksByCode
};
